import { ReactNode } from 'react';
import styled from 'styled-components';
import { Checkbox, CHECKBOX_STATUS } from 'ui/checkbox';
import { colors, spacing } from 'ui/theme';
import { getTargetCheckboxBorderColor } from './DestinationSelectorModal.utils';

export const TargetCheckboxContainer = styled.div<{
  selected: boolean;
  hasError: boolean;
}>`
  display: flex;
  gap: ${spacing.half};
  align-items: center;

  border: ${(props) => `${spacing.single} solid ${getTargetCheckboxBorderColor(props)}`};
  border-radius: ${spacing.threeEights};
  padding: ${spacing.plusHalf};
  margin: ${spacing.half};

  &:hover {
    cursor: pointer;
    border: ${({ selected }) =>
      `${spacing.single} solid ${selected ? colors.green50 : colors.grey50}`};
  }

  box-shadow: 0 ${spacing.single} ${spacing.single} rgb(0 0 0 / 0.06),
    0 0 ${spacing.single} rgb(0 0 0 / 0.06), 0 0 ${spacing.single} rgb(0 0 0 / 0.08);
`;

type TargetCheckboxProps = {
  id: string;
  onClick: () => void;
  selected: boolean;
  children: ReactNode;
  hasError: boolean;
};

export const TargetCheckbox = ({
  id,
  onClick,
  selected,
  children,
  hasError,
}: TargetCheckboxProps) => {
  return (
    <TargetCheckboxContainer
      selected={selected}
      onClick={onClick}
      hasError={hasError}
      data-test={`destination-selector-${id}`}
    >
      <Checkbox status={selected ? CHECKBOX_STATUS.CHECKED : CHECKBOX_STATUS.UNCHECKED} />
      {children}
    </TargetCheckboxContainer>
  );
};
